import styles from "./Modal.module.css";
import { Field, Form, Formik } from "formik";
import Button from "../../../../../components/components-ui/Button/Button";
import { Col, Grid } from "../../../../../components/Grid";
import {
  customStyles,
  SelectSearch,
} from "../../../../../components/components-ui/SelectSearch/SelectSearch";
import api from "../../../../../services/Api";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Select from "react-select";
import { Table } from "../../../../../components/Table";
import { Link } from "react-router-dom";
import { Box } from "@mui/material";
import Loading from "../../../../../components/components-ui/Loading/Loading";
import CustomConfirmAlert from "../../../../../components/components-ui/CustomConfirmAlert/CustomConfirmAlert";

const API_SHOW_RELATORIO = "/relatorio/relatoriototais/";
const API_ATUALIZA_BALANCA = "/relatorio/relatoriototais/edit/";
const API_CONTRAPARTIDA = `/brinde/index`;
const API_ADICIONA_PRODUTO = "/relatorio/relatoriototais/produtos/";
const API_REMOVER_PRODUTO = "/relatorio/relatoriototais/produtos/";
const API_ENCERRAR_RELATORIO = "/relatorio/relatoriototais/encerrar/";

const columnsProdutos = [
  {
    column: "Produto",
  },
  {
    column: "Qtde.",
  },
  // {
  //   column: "Total Litros",
  // },
  {
    column: "Brinde.",
  },
];

function ModalRelatorioDeTotais({
  idBalanca,
  back,
  closeModal,
  recarregaRelatorio,
}) {
  const [dadosBalanca, setDadosBalanca] = useState([]);
  const [itensContrapartida, setItensContrapartida] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(false);

  const getRelatorioDaBalanca = async () => {
    setLoading(true);
    await api
      .get(API_SHOW_RELATORIO + idBalanca)
      .then((res) => {
        setDadosBalanca(res.data.data);
        setProdutos(res.data.balancaProdutos);
      })
      .catch((error) => console.log(error));
    setLoading(false);
  };

  const atualizaBalanca = async (values) => {
    const data = {
      DataBalanca: values?.dataBalanca,
      IdFreguesia: values?.idFreguesia,
      Freguesia: values?.freguesia,
      Letra: values?.letra,
      PesoBruto: values?.pesoBruto,
      IdStatus: values?.status,
      TotalBalanca: values?.totalBalanca,
      TotalCodigoCliente: values?.totalCodigoCliente || null,
      TotalDescarte: values?.totalDescarte,
      TotalDoRelatorio: values?.totalRelatorio || null,
    };

    await api
      .post(API_ATUALIZA_BALANCA + idBalanca, data)
      .then((res) => {
        if (res.data.error === 0) {
          toast.success(res.data.msg);
          recarregaRelatorio();
          closeModal();
          return;
        }
        toast.error(res.data.msg);
      })
      .catch((error) => console.log(error));
  };

  const encerrarRelatorio = (idBalanca) => {
    CustomConfirmAlert({
      subtitle: "Confirmar encerramento desse Relatório de Totais?",
      labelBtnConfirmar: "Encerrar Relatório",
      colorBtnConfirmar: "#f44336f7",
      onConfirm: async () => {
        const promise = api
          .post(API_ENCERRAR_RELATORIO + idBalanca)
          .then((response) => {
            const res = response.data;
            if (res.error !== 0) {
              throw new Error(res.msg || `Erro: ${res.error}`);
            }
            return response;
          });

        toast.promise(promise, {
          pending: "Encerrando relatório...",
          success: {
            render({ data }) {
              const res = data.data;
              if (res.error === 0) {
                return res.msg || "Relatório de totais encerrado com sucesso!";
              }
              throw new Error(res.msg || `Erro: ${res.error}`);
            },
          },
          error: {
            render({ data }) {
              return data?.message || "Erro ao encerrar relatório";
            },
          },
        });

        try {
          const response = await promise;
          const res = response.data;
          recarregaRelatorio();
          closeModal();
        } catch (error) {
          console.error("Erro ao cancelar rota: ", error);
        }
      },
    });
  };

  // Carregar itens do select produtos
  const getItensProdutos = async () => {
    await api
      .get(API_CONTRAPARTIDA)
      .then((res) => setItensContrapartida(res.data))
      .catch((error) => console.log(error));
  };

  //Carregar selects tiposPagamento
  useEffect(() => {
    getRelatorioDaBalanca();
    getItensProdutos();
  }, []);

  function adicionaProduto(values, setFieldValue) {
    const infos = itensContrapartida.find(
      (item) => item.id_brinde === values?.produto?.value
    );

    const item = {
      IDBrinde: values?.produto?.value,
      Brinde: values?.produto?.label,
      QuantidadeSolicitada: values?.qtdProduto,
      Bonificacao: values?.brinde,
      ValorUnitario: infos?.ValorVenda,
      ValorTotal: infos?.ValorVenda * Number(values?.qtdProduto),
      VolumeUnitario: infos?.VolumeUnitario,
      VolumeTotal: infos?.VolumeTotal * Number(values?.qtdProduto),
    };

    if (!values?.produto?.value) {
      toast.error("Selecione uma opção de produto");
      return;
    }

    // Verificar se a quantidade está correta
    if (
      !values?.qtdProduto ||
      !values?.qtdProduto === "" ||
      values?.qtdProduto <= 0
    ) {
      toast.error("Insira uma quantidade válida");
      return;
    }

    // Verificar se o item já foi adicionado
    const verificaItem = produtos.find(
      (item) => item.IDBrinde === values?.produto?.value
    );

    if (verificaItem) {
      toast.error(
        "Item já existente! Se deseja alterar a quantidade exclua e adicione novamente."
      );
      return;
    }

    // Verifica se esta na tela de edição, caso esteja adiciona a contrapartida direto no banco
    if (idBalanca) {
      api
        .post(API_ADICIONA_PRODUTO + idBalanca, item)
        .then((res) => {
          setProdutos([
            ...produtos,
            { IDBalancaProduto: res.data.IDBalancaProduto, ...item },
          ]);
          toast.success(res.data.msg, { autoClose: 2000 });
        })
        .catch(() => toast.error("Algo de errado aconteceu ao adicionar"));
    } else {
      setProdutos([...produtos, item]);
    }

    setFieldValue("produto", { value: null, label: "Selecione" });
    setFieldValue("qtdProduto", "");
    setFieldValue("totalLitros", "");
    setFieldValue("brinde", false);
  }

  function removeProduto(value) {
    // Verifica se está na rota de edição, caso esteja deleta o item no banco
    if (idBalanca) {
      api
        .delete(API_REMOVER_PRODUTO + value?.IDBalancaProduto)
        .then((res) => {
          const itens = produtos.filter(
            (item) => item.IDBalancaProduto !== value?.IDBalancaProduto
          );
          setProdutos([...itens]);
          toast.success(res.data.msg, { autoClose: 2000 });
        })
        .catch((error) => toast.error(error));
    } else {
      const itens = produtos.filter(
        (item) => item.IDBrinde !== value?.IDBrinde
      );
      setProdutos([...itens]);
    }
  }

  const handleChangeProduto = (selectedOption, setFieldValue) => {
    setFieldValue("qtdProduto", "");
    setFieldValue("totalLitros", "");
    setFieldValue("brinde", false);
    setFieldValue("produto", selectedOption); //Seta o valor do select contrapartida como objeto contendo {value: , label: }
  };

  const calculaTotalDescarte = (pesoBruto, totalDescarte, setFieldValue) => {
    const total = pesoBruto - totalDescarte;
    setFieldValue("totalBalanca", total);
  };

  const validationSchema = Yup.object().shape({
    dataBalanca: Yup.string().nullable().required("Campo Obrigatório"),
    idFreguesia: Yup.string().nullable().required("Campo Obrigatório"),
    freguesia: Yup.string().nullable().required("Campo Obrigatório"),
    letra: Yup.string().nullable(),
    status: Yup.string().nullable(),
    pesoBruto: Yup.number()
      .min(0, "Número inválido")
      .nullable(),
    totalDescarte: Yup.number()
      .min(0, "Número inválido")
      .nullable(),
    totalBalanca: Yup.number().nullable(),
    totalCodigoCliente: Yup.number().nullable(),
    totalRelatorio: Yup.number().nullable(),
  });

  return (
    <div className={styles.modal_container}>
      <h2 style={{ textAlign: "center" }}>Relatório de Totais</h2>
      <Formik
        initialValues={{
          id: dadosBalanca?.IdBalanca || "",
          dataBalanca: dadosBalanca?.DataBalanca || "",
          idFreguesia: dadosBalanca?.IdOC || "",
          freguesia: dadosBalanca?.Freguesia || "",
          letra: dadosBalanca?.Letra,
          status: dadosBalanca?.IdStatus || "",
          pesoBruto: dadosBalanca?.PesoBruto || "",
          totalDescarte: dadosBalanca?.TotalDescarte || "",
          totalBalanca: dadosBalanca?.TotalBalanca || "",
          totalCodigoCliente: dadosBalanca?.TotalCodigoCliente || "",
          totalRelatorio: dadosBalanca?.TotalDoRelatorio || "",
        }}
        validationSchema={validationSchema}
        validateOnBlur
        validateOnChange
        enableReinitialize={true}
        onSubmit={(values) => atualizaBalanca(values)}
      >
        {({
          errors,
          touched,
          values,
          isSubmitting,
          isValid,
          setFieldValue,
        }) => (
          <Form>
            {loading ? (
              <div className={styles.loading_container}>
                <Loading display={loading ? "block" : "none"} />
              </div>
            ) : (
              <div>
                <Grid>
                  <Col size={1}>
                    <label>Id</label>
                    <Field type="text" name="id" disabled />
                    {errors.id && touched.id ? (
                      <span className={styles.alertError}>{errors.id}</span>
                    ) : null}
                  </Col>
                  <Col size={3}>
                    <label>Data Balança</label>
                    <Field type="date" name="dataBalanca" />
                    {errors.dataBalanca && touched.dataBalanca ? (
                      <span className={styles.alertError}>
                        {errors.dataBalanca}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label>Id Freg.</label>
                    <Field type="text" name="idFreguesia" disabled />
                    {errors.idFreguesia && touched.idFreguesia ? (
                      <span className={styles.alertError}>
                        {errors.idFreguesia}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label>Freguesia</label>
                    <Field type="text" name="freguesia" />
                    {errors.freguesia && touched.freguesia ? (
                      <span className={styles.alertError}>
                        {errors.freguesia}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={1}>
                    <label>Letra</label>
                    <Field type="text" name="letra" />
                    {errors.letra && touched.letra ? (
                      <span className={styles.alertError}>{errors.letra}</span>
                    ) : null}
                  </Col>
                  <Col size={3}>
                    <label>Status</label>
                    <Field
                      component={SelectSearch}
                      name="status"
                      options={[
                        {
                          value: 1,
                          label: "PENDENTE",
                        },
                        {
                          value: 2,
                          label: "ENCERRADO",
                        },
                        {
                          value: 3,
                          label: "CANCELADO",
                        },
                      ]}
                      disabled
                    />
                    {errors.status && touched.status ? (
                      <span className={styles.alertError}>{errors.status}</span>
                    ) : null}
                  </Col>
                </Grid>
                <Grid>
                  <Col size={2}>
                    <label>Peso Bruto</label>
                    <Field
                      type="number"
                      name="pesoBruto"
                      onBlur={() =>
                        calculaTotalDescarte(
                          values.pesoBruto,
                          values.totalDescarte,
                          setFieldValue
                        )
                      }
                    />
                    {errors.pesoBruto && touched.pesoBruto ? (
                      <span className={styles.alertError}>
                        {errors.pesoBruto}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label>Total Descarte</label>
                    <Field
                      type="number"
                      name="totalDescarte"
                      onBlur={() =>
                        calculaTotalDescarte(
                          values.pesoBruto,
                          values.totalDescarte,
                          setFieldValue
                        )
                      }
                    />
                    {errors.totalDescarte && touched.totalDescarte ? (
                      <span className={styles.alertError}>
                        {errors.totalDescarte}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label>Total Balança</label>
                    <Field type="number" name="totalBalanca" disabled />
                    {errors.totalBalanca && touched.totalBalanca ? (
                      <span className={styles.alertError}>
                        {errors.totalBalanca}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label>Total Código Cliente</label>
                    <Field type="number" name="totalCodigoCliente" />
                    {errors.totalCodigoCliente && touched.totalCodigoCliente ? (
                      <span className={styles.alertError}>
                        {errors.totalCodigoCliente}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label>Total do Relatório</label>
                    <Field type="number" name="totalRelatorio" />
                    {errors.totalRelatorio && touched.totalRelatorio ? (
                      <span className={styles.alertError}>
                        {errors.totalRelatorio}
                      </span>
                    ) : null}
                  </Col>
                </Grid>
                <Grid>
                  <Col size={12}>
                    <label>Produtos</label>
                    <Box border={1} padding={2}>
                      <Grid>
                        <Col size={5}>
                          <label> Produto </label>
                          <Field name="produto">
                            {({ field }) => (
                              <Select
                                {...field}
                                onChange={(selectedOption) =>
                                  handleChangeProduto(
                                    selectedOption,
                                    setFieldValue
                                  )
                                }
                                options={itensContrapartida.map((values) => ({
                                  value: values?.id_brinde,
                                  label: values?.brinde,
                                }))}
                                placeholder="Selecione"
                                styles={customStyles}
                                isClearable
                                menuPortalTarget={document.body}
                              />
                            )}
                          </Field>
                          {errors.produto && touched.produto ? (
                            <span className={styles.alertError}>
                              {errors.produto}
                            </span>
                          ) : null}
                        </Col>
                        <Col size={2}>
                          <label>Quantidade</label>
                          <Field name="qtdProduto">
                            {({ field }) => (
                              <input
                                type="number"
                                step="1"
                                {...field}
                                disabled={!values.produto?.value}
                              />
                            )}
                          </Field>
                          {errors.qtdProduto && touched.qtdProduto ? (
                            <span className={styles.alertError}>
                              {errors.qtdProduto}
                            </span>
                          ) : null}
                        </Col>
                        {/* <Col size={2}>
                          <label>Total Litros</label>
                          <Field name="totalLitros">
                            {({ field }) => (
                              <input
                                type="number"
                                step="1"
                                {...field}
                                disabled={!values.produto?.value}
                              />
                            )}
                          </Field>
                          {errors.TLts && touched.TLts ? (
                            <span className={styles.alertError}>
                              {errors.TLts}
                            </span>
                          ) : null}
                        </Col> */}
                        <Col size={1}>
                          <label>Brinde?</label>
                          <Field type="checkbox" name="brinde" />
                        </Col>
                        <Col size={2}>
                          <Field name="btnContrapartida">
                            {({ field }) => (
                              <Button
                                onClick={() =>
                                  adicionaProduto(values, setFieldValue)
                                }
                                type="button"
                                title="Adicionar"
                              />
                            )}
                          </Field>
                        </Col>
                      </Grid>
                      {/* Produtos */}
                      {produtos.length ? (
                        <Grid>
                          <Col size={12}>
                            <Table
                              edit
                              columns={columnsProdutos}
                              title="Produtos"
                            >
                              {produtos.map((item, index) => (
                                <tr key={index}>
                                  <td
                                    onClick={() => removeProduto(item)}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-trash-alt"></i>
                                  </td>
                                  <td> {item?.Brinde} </td>
                                  <td> {item?.QuantidadeSolicitada} </td>
                                  {/* <td> {item?.VolumeTotal} </td> */}
                                  <td>
                                    {item?.Bonificacao
                                      ? "Com Brinde"
                                      : "Sem Brinde"}
                                  </td>
                                </tr>
                              ))}
                            </Table>
                            {produtos.length === 0 ? (
                              <div
                                style={{
                                  textAlign: "center",
                                  marginBottom: "12px",
                                }}
                              >
                                Nenhuma contrapartida adicionada
                              </div>
                            ) : (
                              ""
                            )}
                          </Col>
                        </Grid>
                      ) : null}
                    </Box>
                  </Col>
                </Grid>
                <div className={styles.buttons_container}>
                  <Button
                    title="Salvar"
                    type="submit"
                    disabled={isSubmitting}
                    className={styles.button_sm}
                  />
                  {dadosBalanca?.IdStatus == 1 && (
                    <Button
                      title="Encerrar"
                      type="button"
                      disabled={isSubmitting}
                      onClick={() => encerrarRelatorio(idBalanca)}
                      color={"tertiary"}
                      className={styles.button_sm}
                    />
                  )}
                  <Button
                    title="Fechar"
                    type="button"
                    disabled={isSubmitting}
                    onClick={() => closeModal()}
                    color={"secondary"}
                    className={styles.button_sm}
                  />
                </div>
                {/* {isSubmitting && (
                <div className={styles.loading_container}>
                  <Loading display={isSubmitting ? "block" : "none"} />
                </div>
              )} */}
              </div>
            )}
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default ModalRelatorioDeTotais;
